import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from '../entities/types/SingleEntityState';
import {
    FAILURE_ORDERS_BY_FILTER,
    FAILURE_ORDERS_BY_FILTER_ID,
    FAILURE_ORDER_FILTER,
    FAILURE_ORDER_PRODUCT_DETAILS,
    FAILURE_UPDATE_BILLING_ADDRESS_ORDER,
    FAILURE_UPDATE_DELIVERY_ADDRESS_ORDER,
    FAILURE_UPDATE_ORDER,
    REQUEST_CLEAR_ORDER_PRODUCT_DETAILS,
    REQUEST_ORDERS_BY_FILTER,
    REQUEST_ORDERS_BY_FILTER_ID,
    REQUEST_ORDER_FILTER,
    REQUEST_ORDER_PRODUCT_DETAILS,
    REQUEST_UPDATE_BILLING_ADDRESS_ORDER,
    REQUEST_UPDATE_DELIVERY_ADDRESS_ORDER,
    REQUEST_UPDATE_ORDER,
    SUCCESS_ORDERS_BY_FILTER,
    SUCCESS_ORDERS_BY_FILTER_ID,
    SUCCESS_ORDER_FILTER,
    SUCCESS_ORDER_PRODUCT_DETAILS,
    SUCCESS_UPDATE_BILLING_ADDRESS_ORDER,
    SUCCESS_UPDATE_DELIVERY_ADDRESS_ORDER,
    SUCCESS_UPDATE_ORDER,
} from './actions';

export function adminOrdersReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_ORDERS_BY_FILTER:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORDERS_BY_FILTER:
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });

        case FAILURE_ORDERS_BY_FILTER:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_ORDERS_BY_FILTER_ID:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORDERS_BY_FILTER_ID:
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        case FAILURE_ORDERS_BY_FILTER_ID:
            return _.assign({}, state, { isFetching: false, error: action.error, content: undefined });
        case REQUEST_UPDATE_ORDER:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_UPDATE_ORDER:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_UPDATE_ORDER:
            return _.assign({}, state, { isFetching: false, error: action.error, content: undefined });
        default:
            return state;
    }
}

export function adminOrderFiltersReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORDER_FILTER:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORDER_FILTER:
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        case FAILURE_ORDER_FILTER:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}

export function adminOrderProductDetailsReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORDER_PRODUCT_DETAILS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORDER_PRODUCT_DETAILS:
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        case FAILURE_ORDER_PRODUCT_DETAILS:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_CLEAR_ORDER_PRODUCT_DETAILS:
            return _.assign({}, state, { isFetching: false, error: undefined, content: undefined });
        case REQUEST_UPDATE_BILLING_ADDRESS_ORDER:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_UPDATE_BILLING_ADDRESS_ORDER:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_UPDATE_BILLING_ADDRESS_ORDER:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_UPDATE_DELIVERY_ADDRESS_ORDER:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_UPDATE_DELIVERY_ADDRESS_ORDER:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_UPDATE_DELIVERY_ADDRESS_ORDER:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}
